import { Module } from 'vuex'
import { mutations } from './mutations'
import { InitialState, ContactInfoState } from './types'
import { RootState } from '@/store/types';

const namespaced: boolean = true

export const contactInfo: Module<ContactInfoState, RootState> = {
  namespaced,
  state: InitialState,
  mutations
}
